import {
  ETAT_CLOTURER,
  ETAT_ENREGISTRE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  ETAT_SANSSUITE,
  TYPE_EDITION_DOSSIER_TEMPO,
  ETAT_BROUILLON,
} from '@/configuration/devisConf';

export const ACTION_BILL = 'facturer';
export const TYPE_EDITION_CMD = 'Commande';

export const ACTION_FUSION = 'fusioner';
export const ACTION_DEFUSION = 'defusioner';
export const ACTION_EN_COURS_RENOUVELLEMENT = 'enCours';
export const ACTION_MARQUER_RENOUVELEE = 'marquerRenouvelee';
export const ACTION_MARQUER_RECONDUIT_TACITEMENT = 'marquerReconduitTacitement';
export const ACTION_EDIT_DATE_FACTURATION = 'majDateFacturation';
export const ACTION_EDIT_COMMENTAIRE = 'editCommentaire';
export const ACTION_REGENERATION_COMMANDE_ACHAT = 'regenererCommandeAchat';
export const ACTION_MARQUER_NE_PAS_RENOUVELER = 'marquerNePasRenouveler';
export const ACTION_FACTURATION = 'facturation';
export const ACTION_ANNULATION = 'annulation';
export const ACTION_ENREGISTREMENT = 'enregistrement';
export const ACTION_CHANGE_DATE = 'changementDate';
export const ACTION_GENERATION = 'generation';
export const ACTION_ECHEANCIER_MASSE = 'genererEcheancierMasse';
export const ACTION_ECHEANCIER_SUPP_MASSE = 'supprimerEcheancierMasse';
export const DATES_RENOUVELLEMENT = 'DatesRenouvellement';
export const DATES_PREAVIS = 'DatesPreavis';

export const DATES_FILTRE_CHOIX = [
  { code: DATES_RENOUVELLEMENT, libelle: 'renouvellementCommande.filtre.choixDates.renouvellement' },
  { code: DATES_PREAVIS, libelle: 'renouvellementCommande.filtre.choixDates.preavis' },
];

export const COMMANDE_ETAT = [
  { code: ETAT_ENREGISTRE, libelle: 'listeCommandes.etat.enregistre' },
  { code: ETAT_FACTURE, libelle: 'listeCommandes.etat.facture' },
  { code: ETAT_FACTURE_PARTIELLEMENT, libelle: 'listeCommandes.etat.facturePartiellement' },
  { code: ETAT_SANSSUITE, libelle: 'listeCommandes.etat.sansSuite' },
  { code: ETAT_CLOTURER, libelle: 'listeCommandes.etat.clos' },
];

export const TYPE_EDITION_COMMANDE = 'Commande';
export const TYPE_EDITION_COMMANDE_MAIL = 'commande';
export const TYPE_EDITION_JUSTIFICATIF = 'JustifPose';
export const TYPE_EDITION_COMMANDE_SANS_LOGO = 'CommandeSansLogo';

export const LISTE_CHOICE_EDITION_COMMANDE = [
  { typeEdition: '', libelle: 'detail.edition.commande', typeDonnee: TYPE_EDITION_COMMANDE },
  { typeEdition: TYPE_EDITION_COMMANDE_SANS_LOGO, libelle: 'detail.edition.commandeSansLogo', typeDonnee: TYPE_EDITION_COMMANDE },
  {
    typeEdition: '',
    libelle: 'detail.edition.commandeDetailLc',
    typeDonnee: TYPE_EDITION_COMMANDE,
    parametresAdditionnels: { DetailLc: 'true' },
  },
  { typeEdition: '', libelle: 'detail.edition.justificatifPose', typeDonnee: TYPE_EDITION_JUSTIFICATIF },
  {
    typeEdition: '',
    libelle: 'detail.edition.dossierTempo',
    typeDonnee: TYPE_EDITION_DOSSIER_TEMPO,
    parametresAdditionnels: {
      Type: 'Commande',
      AffichageCumul: false,
    },
  },
  {
    typeEdition: '',
    libelle: 'detail.edition.dossierTempoAvecCumul',
    typeDonnee: TYPE_EDITION_DOSSIER_TEMPO,
    parametresAdditionnels: {
      Type: 'Commande',
      AffichageCumul: true,
    },
  },
  {
    typeEdition: '',
    libelle: 'catalogue.edition.diaporama',
    typeDonnee: 'Diaporama',
    parametresAdditionnels: {
      typeSource: 'dcf',
      isCBA: true,
    },
  },
];

export const TYPE_DONNEE_EXCEL_COMMANDE_A_FACTURER = 'commandesAFacturer';
export const EXPORT_EXCEL_TYPE_DONNEES_COMMANDE = 'commande';
export const EXPORT_EXCEL_TYPE_EXPORT_ECHEANCIER = 'echeancier';
export const EXPORT_EXCEL_LIGNE_COMMANDE = 'lignecommandes';
export const EXPORT_EXCEL_RETOUR_AFFICHAGE = 'retouraffichage';

export const STORE_NAME_PLAN_MEDIA_VENTE = 'PlanMVentes';
export const STORE_NAME_COMMANDE_LIGNES_COMMANDE = 'commandeParLigneCommande';

export const COMMANDE_ACHAT_BAILLEUR_ETAT = [
  { code: ETAT_BROUILLON, libelle: 'listeDevis.status.brouillon' },
  { code: ETAT_ENREGISTRE, libelle: 'listeCommandes.etat.enregistre' },
  { code: ETAT_FACTURE, libelle: 'listeCommandes.etat.facture' },
];
